import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Monitor, DollarSign, HeadphonesIcon, BookOpen, Users } from "lucide-react";
import { PROGRAM_STATS, PROGRAM_OVERVIEW } from "../../constants";

export function ProgramSection() {
  const programDetails = [
    { title: "対象研修", content: "Instagram / TikTok / X / LINE / YouTube の運用・制作スキル", icon: BookOpen },
    { title: "形式", content: "オンラインまたは訪問型の座学＋ワークショップ", icon: Monitor },
    { title: "助成内容", content: "研修費用の最大75%（中小企業の場合）", icon: DollarSign },
    { title: "費用", content: "1名あたり 400,000円（税込）※助成適用時、実質負担額 100,000円程度/名", icon: Users },
    { title: "サポート内容", content: "カリキュラム設計、研修実施、アカウント運用・助成金申請サポート", icon: HeadphonesIcon },
  ];

  return (
    <section className="py-20 px-4 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="mb-4 text-3xl md:text-4xl text-gray-900">
            本プログラムの概要
          </h2>
          <div className="w-24 h-1 bg-black mx-auto mb-8"></div>
          <p className="text-lg text-gray-600 max-w-4xl mx-auto">
            {PROGRAM_OVERVIEW}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {programDetails.map((detail, index) => (
            <Card key={index} className="border-gray-200 shadow-sm hover:shadow-md transition-shadow">
              <CardHeader>
                <CardTitle className="flex items-center text-xl text-gray-900">
                  <div className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center mr-3">
                    <detail.icon className="w-5 h-5 text-black" />
                  </div>
                  {detail.title}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-gray-700">{detail.content}</p>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="bg-gray-50 p-8 rounded-xl">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div>
              <div className="text-3xl mb-2 text-black">{PROGRAM_STATS.TOTAL_SESSIONS}</div>
              <div className="text-sm text-gray-600">研修回数</div>
            </div>
            <div>
              <div className="text-3xl mb-2 text-black">{PROGRAM_STATS.TOTAL_HOURS}</div>
              <div className="text-sm text-gray-600">総研修時間</div>
            </div>
            <div>
              <div className="text-3xl mb-2 text-black">実践重視</div>
              <div className="text-sm text-gray-600">座学＋ワークショップ</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
